module.exports = __webpack_public_path__ + "img/performanceExercise.3940cff3.png";